import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const VERSION = 0;

export async function getDeploymentDbInfo(appId: string, deploymentId: string) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000
    };

    const result = await httpNetworking.simpleGETRequest(
        `${API_URL}/saas/${appId}/deployment/db/?deploymentId=${deploymentId}`,
        options,
        VERSION
    );
    return result.data;
}
